export default __webpack_public_path__ + "static/media/BrainBreak cards69.4fc59041.png";